
import { Button } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { setSelectedToggle } from 'src/slices/charts';
import { useDispatch, useSelector } from 'src/store';



const Toggle = () => {
  const { selectedToggle } = useSelector((state) => state.charts_store)
  const dispatch = useDispatch()

  const chart = selectedToggle === "chart"

  const handleAlignment = (newAlignment) => {
    dispatch(setSelectedToggle(newAlignment))
  }

  return (

    <>
      {chart ? (
        <Button
          variant="contained" 
          onClick={() => handleAlignment("map")} 
          size="small"
          startIcon={<ArrowBackIcon />}
          sx={{ 
            fontFamily: "Space Grotesk",
            fontWeight: "500", 
            height: "40px",
            fontSize: "20px",
          }}
        >
          VER MAPA
        </Button>
      ) : (
        <Button
          variant="contained" 
          size="small"
          onClick={() => handleAlignment("chart")} 
          endIcon={<ArrowForwardIcon />}
          sx={{ 
            fontFamily: "Space Grotesk",
            fontWeight: "500", 
            height: "40px",
            fontSize: "20px",
          }}
        >
          VER GRÁFICOS
        </Button>
      )}
    </>
  )
}

export default Toggle